import { ButtonToggleLogic as ButtonToggle } from './ButtonToggle.logic'

export default ButtonToggle
